const contactLinks = [
  {
    key: 1,
    title: "email",
    icon: "fas fa-envelope",
    color: "#EA4335",
    iconColor: "white",
    url: "mailto:marielpacada08@gmail.com",
  },

  {
    key: 2,
    title: "github",
    icon: "fab fa-github",
    color: "#36454F",
    iconColor: "white",
    url: "https://github.com/marielpacada",
  },

  {
    key: 3,
    title: "resume",
    icon: "fas fa-file-alt",
    color: "#967bb6",
    iconColor: "white",
    url: "mariel_pacada_resume.pdf",
  },
];

export default contactLinks;
